{
  "helloWorld": "Hallo, Welt!",
  "clickMe": "Klick mich",
  "healthCheckFailed": "Gesundheitscheck fehlgeschlagen",
  "errors": {
    "unexpected": "Ein unerwarteter Fehler ist aufgetreten"
  },
  "error": {
    "title": "Etwas ist schiefgelaufen",
    "description": "Ein unerwarteter Fehler ist aufgetreten. Du kannst es erneut versuchen oder zur Startseite zurückkehren.",
    "tryAgain": "Erneut versuchen",
    "goHome": "Zur Startseite"
  },
  "dev": {
    "errorPreview": "Fehlervorschau"
  },
  "actions": {
    "label": "Aktionen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "expand": "Aufklappen",
    "collapse": "Zuklappen"
  },
  "validation": {
    "tooLong": "Maximal {{max}} Zeichen erlaubt",
    "tooShort": "Erforderlich",
    "invalidFormat": "Ungültiges Format",
    "invalid": "Ungültiger Wert"
  },
  "nav": {
    "workspace": "Arbeitsbereich",
    "controlCenter": "Kontrollzentrum",
    "jobs": "Stellen",
    "analytics": "Analysen",
    "company": "Unternehmen",
    "agentCommunications": "Agent-Kommunikation",
    "integrations": "Integrationen",
    "suggestedCandidates": "Vorgeschlagene Kandidaten",
    "unsolicitedApplications": "Initiativbewerbungen",
    "team": "Team",
    "templates": "Vorlagen",
    "workflow": "Workflow",
    "settings": "Einstellungen",
    "language": "Sprache",
    "help": "Hilfe",
    "logout": "Abmelden",
    "administration": "Administration",
    "adminTenant": "Mandanteneinstellungen",
    "adminOrganizations": "Organisationen",
    "adminDepartments": "Abteilungen",
    "adminFeedback": "Feedback",
    "openMenu": "Menü öffnen",
    "mcp": "MCP",
    "orgSettings": "Organisationseinstellungen"
  },
  "admin": {
    "tenants": {
      "title": "Mandanten",
      "newTenant": "Neuer Mandant",
      "columns": {
        "name": "Name",
        "createdAt": "Erstellt am",
        "actions": "Aktionen"
      },
      "createDialog": {
        "title": "Mandant erstellen",
        "namePlaceholder": "Acme GmbH"
      },
      "editDialog": {
        "title": "Mandant bearbeiten"
      }
    },
    "tenant": {
      "title": "Mandanteneinstellungen",
      "name": "Mandantenname",
      "save": "Änderungen speichern",
      "saved": "Gespeichert"
    },
    "organizations": {
      "title": "Organisationen",
      "newOrg": "Neue Organisation",
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "tenant": "Mandant",
        "createdAt": "Erstellt am",
        "actions": "Aktionen",
        "viewWorkspace": "Arbeitsbereich anzeigen"
      },
      "createDialog": {
        "title": "Organisation erstellen",
        "namePlaceholder": "Acme GmbH",
        "slugPlaceholder": "acme-gmbh",
        "newTenant": "Neuer Mandant",
        "existingTenant": "Bestehender Mandant",
        "tenantName": "Mandantenname",
        "tenantNamePlaceholder": "Acme GmbH",
        "selectTenant": "Mandant auswählen"
      },
      "editDialog": {
        "title": "Organisation bearbeiten",
        "language": "Sprache",
        "languagePlaceholder": "Sprache auswählen"
      },
      "deleteConfirm": {
        "title": "Organisation löschen",
        "description": "Dadurch werden auch alle Abteilungen in dieser Organisation gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
        "confirm": "Löschen",
        "cancel": "Abbrechen"
      }
    },
    "departments": {
      "title": "Abteilungen",
      "newDept": "Neue Abteilung",
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "createdAt": "Erstellt am",
        "actions": "Aktionen"
      },
      "createDialog": {
        "title": "Abteilung erstellen",
        "namePlaceholder": "Entwicklung",
        "slugPlaceholder": "entwicklung"
      },
      "editDialog": {
        "title": "Abteilung bearbeiten"
      },
      "deleteConfirm": {
        "title": "Abteilung löschen",
        "description": "Diese Aktion kann nicht rückgängig gemacht werden.",
        "confirm": "Löschen",
        "cancel": "Abbrechen"
      }
    },
    "viewingOrg": {
      "banner": "Anzeige: {{name}}",
      "leave": "Verlassen"
    },
    "feedback": {
      "title": "Feedback",
      "columns": {
        "rating": "Bewertung",
        "modality": "Typ",
        "candidate": "Kandidat",
        "job": "Stelle",
        "org": "Organisation",
        "notes": "Anmerkungen",
        "date": "Datum"
      },
      "modality": {
        "voice": "Sprache",
        "text": "Chat"
      },
      "thumbs": {
        "up": "Positiv",
        "down": "Negativ"
      },
      "filter": {
        "all": "Alle",
        "up": "Positiv",
        "down": "Negativ",
        "hasNotes": "Mit Anmerkungen"
      },
      "stats": {
        "title": "Negativrate",
        "period": "Letzte 7 Tage",
        "wowUp": "+{{delta}}pp",
        "wowDown": "-{{delta}}pp",
        "wowFlat": "Keine Veränderung",
        "wowNoPrev": "Keine Vordaten",
        "noData": "Keine Daten"
      },
      "noFeedback": "Noch kein Feedback",
      "noNotes": "Kein schriftlicher Kommentar"
    }
  },
  "team": {
    "title": "Team",
    "invite": "Kollegen einladen",
    "search": "Nach Name, E-Mail, Abteilung suchen...",
    "department": "Abteilung",
    "roles": {
      "admin": "Admin",
      "org_manager": "Org-Manager",
      "dept_manager": "Abteilungsleiter",
      "user": "Benutzer"
    },
    "columns": {
      "name": "Name",
      "email": "E-Mail",
      "role": "Rolle",
      "actions": "Aktionen"
    },
    "inviteDialog": {
      "title": "Kollegen einladen",
      "name": "Name",
      "namePlaceholder": "Max Mustermann",
      "email": "E-Mail-Adresse",
      "emailPlaceholder": "kollege@unternehmen.de",
      "role": "Rolle",
      "departments": "Abteilungen",
      "submit": "Einladung senden"
    },
    "actions": {
      "changeRole": "Rolle ändern",
      "addDepartment": "Zu Abteilung hinzufügen",
      "removeDepartment": "Aus Abteilung entfernen",
      "removeFromOrg": "Aus Organisation entfernen"
    },
    "noResults": "Keine Ergebnisse gefunden.",
    "noMembers": "Noch keine Teammitglieder."
  },
  "jobs": {
    "title": "Stellen",
    "backToJobs": "Stellen",
    "newJob": "Neue Stelle",
    "createNewJob": "Neue Stelle erstellen",
    "importFromAts": "Aus {{atsName}} importieren",
    "searchPlaceholder": "Stellen suchen...",
    "completedPlaceholder": "{{completed}} von {{total}} abgeschlossen",
    "tabs": {
      "active": "Aktiv",
      "archived": "Archiviert"
    },
    "columns": {
      "name": "Name",
      "createdBy": "Erstellt von",
      "createdAt": "Erstellt am",
      "actions": "Aktionen"
    },
    "empty": "Keine Stellen gefunden.",
    "emptyTitle": "Noch keine Stellen",
    "emptyDescription": "Erstelle deine erste Stelle oder importiere sie aus deinem ATS.",
    "emptyArchivedTitle": "Keine archivierten Stellen",
    "emptyArchivedDescription": "Archivierte Stellen werden hier angezeigt.",
    "emptySearchDescription": "Keine Stellen entsprechen deiner Suche.",
    "actions": {
      "archive": "Archivieren",
      "archiveConfirmTitle": "Stelle archivieren",
      "archiveConfirmDescription": "Bist du sicher, dass du diese Stelle archivieren möchtest? Sie wird in den Tab Archiviert verschoben.",
      "archiveSuccess": "Stelle archiviert",
      "archiveError": "Stelle konnte nicht archiviert werden. Bitte versuche es erneut."
    },
    "createError": "Stelle konnte nicht erstellt werden. Bitte versuche es erneut.",
    "status": {
      "active": "Aktiv",
      "archived": "Archiviert"
    },
    "setupStatus": {
      "draft": "Entwurf",
      "questions_pending": "Einrichtung nötig",
      "ready": "Bereit",
      "active": "Aktiv"
    },
    "applicantSync": {
      "syncingBanner": "Kandidaten werden von {{provider}} abgerufen...",
      "failedBanner": "Kandidatensynchronisation fehlgeschlagen",
      "adminActions": "Admin-Aktionen",
      "resyncLabel": "Bewerber jetzt synchronisieren",
      "lastSyncedAt": "Zuletzt synchronisiert: {{date}}",
      "addDemoApplicant": "Demobewerber hinzufügen"
    },
    "detail": {
      "tabs": {
        "candidates": "Kandidaten",
        "results": "Ergebnisse",
        "settings": "Einstellungen"
      },
      "info": {
        "title": "Stelleninformationen",
        "employer": "Arbeitgeber",
        "location": "Standort",
        "description": "Beschreibung",
        "modality": "Interviewformat",
        "languages": "Sprachen",
        "atsProvider": "ATS-Anbieter",
        "atsId": "ATS-Stellen-ID",
        "noDescription": "Keine Beschreibung vorhanden."
      },
      "questions": {
        "title": "Interviewfragen",
        "empty": "Keine Fragen für diese Stelle konfiguriert.",
        "optional": "Optional",
        "categories": {
          "eligibility": "Eignung",
          "nice_to_have": "Wünschenswert",
          "job_preview": "Joberwartungen",
          "assessment": "Bewertung",
          "information": "Information"
        }
      }
    }
  },
  "wizard": {
    "step": "Schritt {{current}} von {{total}}",
    "back": "Zurück",
    "next": "Weiter",
    "goLive": "Aktivieren",
    "saveAndContinue": "Speichern & weiter",
    "manual": {
      "title": "Neue Stelle",
      "step1Title": "Grundinformationen",
      "step2Title": "Interviewfragen",
      "step3Title": "Bestätigen & aktivieren"
    },
    "import": {
      "title": "Aus ATS importieren",
      "step0Title": "Stellen auswählen",
      "step1Title": "Phasen zuordnen",
      "step2Title": "Intervieweinstellungen",
      "step3Title": "Interviewfragen",
      "step4Title": "Bestätigen & aktivieren"
    },
    "stageSelector": {
      "title": "Pipeline-Phasen zuordnen",
      "description": "Wähle aus, welche Phase in jeder Stelle der jeweiligen Kiku-Aktion entspricht. Vorausgefüllt, wo Phasennamen mit deinen Standards übereinstimmten.",
      "continue": "Weiter",
      "loading": "Phasen werden geladen..."
    },
    "basicInfo": {
      "title": "Stellenbezeichnung",
      "titlePlaceholder": "z.B. Senior Softwareentwickler",
      "description": "Stellenbeschreibung",
      "descriptionPlaceholder": "Beschreibe die Rolle, Aufgaben und Anforderungen...",
      "descriptionHint": "Wird von AI genutzt, um relevante Interviewfragen zu generieren",
      "employer": "Arbeitgebername (optional)",
      "employerPlaceholder": "z.B. Acme GmbH",
      "modality": "Interviewformat",
      "modalityText": "Textchat",
      "modalityTextDesc": "Der Kandidat tippt Antworten in einer Chat-Oberfläche",
      "modalityVoice": "Sprachinterview",
      "modalityVoiceDesc": "Live-Audio-Interview in einem virtuellen Meetingraum",
      "languages": "Interviewsprache(n)",
      "languagesHint": "Wähle mindestens eine Sprache",
      "languagesSearch": "Sprachen suchen...",
      "languagesEmpty": "Keine Sprache gefunden.",
      "modalityRequired": "Wähle mindestens ein Interviewformat",
      "languagesRequired": "Wähle mindestens eine Sprache"
    },
    "atsSelector": {
      "title": "Stellen zum Importieren auswählen",
      "search": "Stellen suchen...",
      "selectAll": "Alle auswählen",
      "selected": "{{count}} ausgewählt",
      "noJobs": "Keine aktiven Stellen in deinem ATS gefunden",
      "noDescription": "Keine Beschreibung verfügbar — AI generiert nur aus dem Titel",
      "continue": "Mit {{count}} Stelle(n) fortfahren"
    },
    "sharedSettings": {
      "title": "Intervieweinstellungen",
      "subtitle": "Diese Einstellungen gelten für alle importierten Stellen",
      "employer": "Arbeitgebername",
      "employerPlaceholder": "z.B. Acme Corp"
    },
    "questions": {
      "title": "Interviewfragen",
      "generateError": "Fragen konnten nicht generiert werden. Bitte versuche es erneut.",
      "retry": "Erneut versuchen",
      "generating": "Fragen werden vorbereitet, um die besten Kandidaten zu finden…",
      "generatingHint": "Das dauert normalerweise einige Sekunden",
      "addQuestion": "Frage hinzufügen",
      "categories": {
        "eligibility": "Eignung",
        "nice_to_have": "Wünschenswert",
        "job_preview": "Realistische Jobvorschau",
        "assessment": "Bewertung",
        "information": "Informationserfassung"
      },
      "categoryDescriptions": {
        "eligibility": "Ja/Nein-Fragen zu zwingenden Anforderungen",
        "nice_to_have": "Ja/Nein-Fragen zu wünschenswerten, aber nicht zwingenden Qualifikationen",
        "job_preview": "Hebt einen herausfordernden Aspekt der Rolle hervor. Hilft sicherzustellen, dass der Kandidat versteht, was die Rolle beinhaltet, und verhindert spätere Fluktuation",
        "assessment": "Verhaltens- und Kompetenzfragen",
        "information": "Fragen zur Kontexterfassung — werden nicht in die Bewertung einbezogen"
      },
      "categoryPurpose": {
        "eligibility": "Bestanden oder durchgefallen",
        "job_preview": "Bestanden oder durchgefallen",

        "assessment": "Bewertet",
        "information": "Nur zur Information"
      },
      "optional": "Optional",
      "competency": "Kompetenz",
      "scoringExamples": "Bewertungsanker",
      "editScoringExamples": "Bewertungsanker bearbeiten",
      "regenerateScoringExamples": "Bewertungsanker neu generieren",
      "dontRegenerateScoringExamples": "Bewertungsanker nicht neu generieren",
      "regeneratingScoringExamples": "Wird neu generiert...",
      "regenerateScoringError": "Bewertungsanker konnten nicht neu generiert werden",
      "score1": "Note 1 — Schwach",
      "score3": "Note 3 — Ausreichend",
      "score5": "Note 5 — Ausgezeichnet",
      "aiGenerated": "KI-generiert"
    },
    "confirm": {
      "title": "Bereit zur Aktivierung",
      "jobsCount": "{{count}} Stelle(n) werden aktiviert",
      "questionsCount": "{{count}} Interviewfrage(n)",
      "modality": "Format",
      "languages": "Sprachen",
      "goLiveHint": "Kandidaten können sofort nach der Aktivierung mit Interviews beginnen."
    }
  },
  "login": {
    "title": "Bei Kiku anmelden",
    "subtitle": "Verwalte deine Recruiting-Pipeline.",
    "cta": "Anmelden",
    "waitingForLogin": "Warte auf Anmeldung...",
    "disclosure": "Sie interagieren mit einem KI-System. Kiku nutzt KI zur Unterstützung bei der Personalbeschaffung — alle Entscheidungen unterliegen einer menschlichen Überprüfung.",
    "errors": {
      "not_provisioned": "Dein Konto ist noch nicht eingerichtet. Wende dich an deinen Administrator.",
      "missing_code": "Authentifizierung fehlgeschlagen. Bitte versuche es erneut.",
      "session_expired": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an."
    }
  },
  "settings": {
    "profile": {
      "title": "Profil",
      "name": "Name",
      "email": "E-Mail",
      "role": "Rolle",
      "departments": "Abteilungen"
    }
  },
  "integrations": {
    "title": "Integrationen",
    "ats": {
      "title": "ATS-Verbindung",
      "description": "Verbinde dein Bewerbermanagementsystem, um Stellen zu synchronisieren und Kandidatenphasen zu verwalten.",
      "provider": "Anbieter",
      "apiKey": "API-Schlüssel",
      "apiKeyPlaceholder": "API-Schlüssel eingeben",
      "apiKeySet": "Schlüssel gespeichert — neuen Wert eingeben zum Ersetzen",
      "save": "Verbindung speichern",
      "verify": "Verbindung prüfen",
      "verifyStatus": {
        "valid": "Verbunden",
        "invalid": "Ungültiger Schlüssel",
        "error": "Überprüfung fehlgeschlagen",
        "idle": "Nicht überprüft",
        "loading": "Wird überprüft..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan",
        "logicmelon": "LogicMelon",
        "teamtailorDescription": "Teamtailor ist eine Recruiting-Plattform, die Unternehmen dabei hilft, Top-Kandidaten zu gewinnen, zu fördern und einzustellen.",
        "recmanDescription": "RecMan ist ein Recruiting-System für Personal- und Vermittlungsagenturen im nordischen Markt.",
        "logicmelonDescription": "LogicMelon ist ein Multi-Posting-ATS für Hochvolumen-Recruiting, beliebt im britischen Bildungssektor."
      }
    },
    "stageMapping": {
      "title": "Phasenzuordnung",
      "description": "Ordne deine ATS-Phasen den Kiku-Workflow-Phasen zu.",
      "initialStage": "Anfangsphase",
      "passInterviewStage": "Interview bestanden",
      "failInterviewStage": "Interview nicht bestanden",
      "recommendedStage": "Empfohlen",
      "selectStage": "Phase auswählen",
      "save": "Zuordnung speichern"
    },
    "errors": {
      "notConfigured": "Kein ATS konfiguriert. Speichere zuerst deine Verbindung.",
      "fetchStagesFailed": "Phasen konnten nicht aus deinem ATS geladen werden.",
      "saveFailed": "Konfiguration konnte nicht gespeichert werden."
    }
  },
  "applications": {
    "title": "Bewerbungen",
    "newCandidate": "Neuer Kandidat",
    "addCandidate": "Neuen Kandidaten hinzufügen",
    "importFromCsv": "Aus CSV importieren",
    "importDialog": {
      "title": "Kandidaten importieren",
      "back": "Zurück",
      "next": "Weiter",
      "upload": {
        "hint": "CSV-Datei hierher ziehen oder klicken zum Durchsuchen",
        "csvOnly": "Nur CSV-Dateien",
        "browse": "Durchsuchen"
      },
      "mapping": {
        "headerRow": "Erste Zeile ist eine Kopfzeile",
        "nameColumn": "Namensspalte",
        "emailColumn": "E-Mail-Spalte",
        "phoneColumn": "Telefonspalte",
        "notMapped": "— nicht zugeordnet —",
        "column": "Spalte",
        "preview": "Vorschau"
      },
      "review": {
        "allValid": "Alle {{count}} Kandidaten sind gültig",
        "summary": "{{valid}} gültig · {{invalid}} ungültig",
        "skipInvalid": "Ungültige Zeilen überspringen und {{count}} gültige Kandidaten importieren",
        "recheck": "Erneut prüfen",
        "import": "{{count}} Kandidaten importieren",
        "colName": "Name",
        "colEmail": "E-Mail",
        "colPhone": "Telefon",
        "colStatus": "Status"
      },
      "errors": {
        "nameRequired": "Erforderlich",
        "emailInvalid": "Ungültige E-Mail",
        "emailDuplicate": "Doppelte E-Mail in dieser Datei",
        "phoneInvalid": "Landesvorwahl erforderlich (z.B. +49...)"
      },
      "success": {
        "title": "Import abgeschlossen",
        "body": "{{created}} importiert, {{conflict}} hatten bereits Bewerbungen (übersprungen), {{error}} fehlgeschlagen.",
        "done": "Fertig"
      }
    },
    "screening": "Screening",
    "aiRanked": "KI-Ranking",
    "emptyStage": "Keine Bewerbungen",
    "emptyTitle": "Noch keine Kandidaten",
    "emptyDescription": "Füge deinen ersten Kandidaten hinzu, um mit der Prüfung von Bewerbungen zu beginnen.",
    "emptySearchDescription": "Keine Kandidaten entsprechen deiner Suche.",
    "searchPlaceholder": "Nach Name, E-Mail oder Telefon suchen",
    "createDialog": {
      "title": "Bewerbung hinzufügen",
      "name": "Vollständiger Name",
      "namePlaceholder": "z.B. Max Mustermann",
      "email": "E-Mail-Adresse",
      "emailPlaceholder": "z.B. max@beispiel.de",
      "phoneNumber": "Telefonnummer",
      "phoneNumberPlaceholder": "z.B. 0171-1234567",
      "phoneCountryCode": "Landesvorwahl",
      "phoneCountryCodePlaceholder": "z.B. +49",
      "submit": "Bewerbung erstellen"
    },
    "errors": {
      "conflict": "Dieser Kandidat hat bereits eine Bewerbung für diese Stelle."
    },
    "detail": {
      "title": "Bewerbungsdetails",
      "tabs": {
        "application": "Bewerbung",
        "profile": "Profil",
        "activity": "Aktivität"
      },
      "stage": "Phase",
      "interviewLink": "Interviewlink",
      "interviewStatus": "Interviewstatus",
      "copyLink": "Link kopieren",
      "linkCopied": "Kopiert!",
      "noInterview": "Keine Interviewsitzung gefunden",
      "noResults": {
        "title": "Interview nicht abgeschlossen",
        "description": "Dieser Kandidat hat das Interview noch nicht absolviert. Teile den Interviewlink, um zu beginnen."
      },
      "inProgress": {
        "title": "Interview läuft",
        "description": "Dieser Kandidat hat das Interview begonnen. Die Ergebnisse erscheinen hier, sobald es abgeschlossen ist."
      },
      "openInterview": "Interview öffnen",
      "commChannel": {
        "label": "Senden über",
        "manual": "Manuell",
        "email": "E-Mail",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "Ausstehend",
        "in_progress": "In Bearbeitung",
        "completed": "Abgeschlossen",
        "expired": "Abgelaufen"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Zeilen pro Seite",
    "rowsSelected": "{{count}} von {{total}} Zeile(n) ausgewählt.",
    "pageOf": "Seite {{page}} von {{total}}",
    "previous": "Zurück",
    "next": "Weiter"
  },
  "screening": {
    "title": "Screening-Interview",
    "aiDisclosure": "Sie chatten mit Sara, einer KI-Assistentin für Personalbeschaffung",
    "selectLanguage": "Wählen Sie Ihre bevorzugte Sprache",
    "selectLanguageDescription": "Das Interview wird in der von Ihnen gewählten Sprache geführt",
    "startInterview": "Interview starten",
    "previewJobTitle": "Beispielstelle — Beispielunternehmen",
    "typeMessage": "Ihre Nachricht eingeben...",
    "send": "Senden",
    "typing": "Sara tippt...",
    "submitInterview": "Interview abschicken",
    "loading": "Interview wird geladen...",
    "completed": {
      "title": "Interview abgeschlossen",
      "submitted": "Interview erfolgreich eingereicht",
      "message": "Vielen Dank, dass Sie das Interview für {{jobTitle}} abgeschlossen haben. Ein Recruiter wird Ihre Antworten prüfen und sich bei Ihnen melden."
    },
    "expired": {
      "title": "Interview abgelaufen",
      "message": "Dieser Interviewlink ist abgelaufen. Bitte kontaktieren Sie den Recruiter für eine neue Einladung."
    },
    "notFound": {
      "title": "Interview nicht gefunden",
      "message": "Dieser Interviewlink ist ungültig. Bitte überprüfen Sie den Link und versuchen Sie es erneut."
    },
    "feedback": {
      "helpUsImprove": "Helfen Sie uns, besser zu werden",
      "teaser": "Wie war das Interviewerlebnis?",
      "overallPrompt": "Wie war das gesamte Interviewerlebnis?",
      "disclaimer": "Wir freuen uns über Ihr Feedback — es ist anonym und hat keinen Einfluss auf Ihre Bewerbung.",
      "prompt": "Wie lief das Interview?",
      "good": "Gut",
      "bad": "Schlecht",
      "notesLabel": "Weitere Anmerkungen?",
      "notesPlaceholder": "Erzählen Sie uns mehr (optional)...",
      "skip": "Überspringen",
      "submit": "Feedback absenden",
      "submitError": "Feedback konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
    },
    "technicalIssue": {
      "buttonLabel": "Technisches Problem?",
      "modalTitle": "Technisches Problem melden",
      "modalDescription": "Beschreiben Sie das aufgetretene Problem. Ihr Feedback wird gesendet und das Interview wird neu gestartet.",
      "notesLabel": "Was ist schiefgelaufen?",
      "notesPlaceholder": "z.B. Die Seite ist eingefroren und ich habe meinen Fortschritt verloren...",
      "submitButton": "Feedback senden und neu starten",
      "submitError": "Senden fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "cancel": "Abbrechen"
    },
    "error": {
      "title": "Etwas ist schiefgelaufen",
      "message": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
      "sendFailed": "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
    },
    "languages": {
      "en": "Englisch",
      "da": "Dänisch",
      "sv": "Schwedisch",
      "de": "Deutsch",
      "fr": "Französisch",
      "es": "Spanisch",
      "nl": "Niederländisch",
      "pl": "Polnisch",
      "fi": "Finnisch",
      "ro": "Rumänisch"
    },
    "landing": {
      "badge": "BEWERBUNGSGESPRÄCH",
      "greeting": "Hallo {{name}}! Schön, dass Sie hier sind. Dies ist eine Einladung zu einem kurzen Online-Screening-Interview mit einer KI, um Sie kennenzulernen. Nehmen Sie sich Zeit und starten Sie, wenn Sie bereit sind.",
      "startChat": "Chat-Interview starten",
      "startVoice": "Sprachinterview starten",
      "or": "oder",
      "minutes": "{{count}} Minuten",
      "questions": "{{count}} Fragen"
    },
    "modality": {
      "title": "Interviewformat wählen",
      "description": "Wählen Sie, wie Sie das Interview absolvieren möchten",
      "text": "Textinterview",
      "textDescription": "Tippen Sie Ihre Antworten im Chat",
      "voice": "Sprachinterview",
      "voiceDescription": "Sprechen Sie Ihre Antworten laut aus"
    },
    "deviceTest": {
      "title": "Audio überprüfen",
      "description": "Stellen Sie sicher, dass Ihr Mikrofon und Ihre Lautsprecher funktionieren, bevor Sie beginnen",
      "microphone": "Mikrofon",
      "speakers": "Lautsprecher",
      "testMicrophone": "Mikrofonzugriff erlauben",
      "testSpeakers": "Testton abspielen",
      "playAgain": "Erneut abspielen",
      "requestingPermission": "Berechtigung wird angefordert...",
      "microphoneDenied": "Mikrofonzugriff wurde verweigert. Bitte erlauben Sie den Zugriff in Ihren Browsereinstellungen.",
      "confirm": "Alles funktioniert — Interview starten"
    },
    "voice": {
      "title": "Sprachinterview",
      "connecting": "Verbindung wird hergestellt...",
      "recording": "Aufnahme",
      "interviewInProgress": "Interview läuft",
      "inProgress": "Interview läuft — sprechen Sie natürlich",
      "muted": "Ihr Mikrofon ist stummgeschaltet",
      "finished": "Interview abgeschlossen — vielen Dank!",
      "alreadyInProgress": "Interview läuft bereits",
      "alreadyInProgressMessage": "Ihr Sprachinterview ist derzeit aktiv. Ein Neustart bricht die aktuelle Sitzung ab — tun Sie dies nur, wenn Sie nicht mehr verbunden sind.",
      "retryButton": "Interview neu starten"
    }
  },
  "scoring": {
    "title": "Interviewergebnisse",
    "pending": "Bewertung läuft...",
    "processing": "KI wertet das Interview aus...",
    "failed": "Bewertung fehlgeschlagen",
    "overallScore": "Gesamtbewertung",
    "overallScoreTooltip": "Punktzahl von 0–100, basierend auf dem Durchschnitt aller Bewertungsfragen, angepasst für Eignung und Joberwartungen.",
    "outcome": "Ergebnis",
    "outcomes": {
      "pass": "Bestanden",
      "fail": "Nicht bestanden"
    },
    "summary": "Zusammenfassung",
    "eligibility": "Eignung",
    "niceToHave": "Wünschenswert",
    "expectations": "Joberwartungen",
    "assessment": "Bewertung",
    "information": "Informationserfassung",
    "scoringAnchors": "Bewertungsanker",
    "candidateAnswer": "Antwort des Kandidaten",
    "transcript": "Interviewprotokoll",
    "viewInTranscript": "Im Protokoll anzeigen",
    "copyPasteDetected": "Kopierte Antwort",
    "copyPasteWarning": "Kopieren und Einfügen in diesem Interview erkannt",
    "copyPasteWarningTooltip": "Eine oder mehrere Antworten des Kandidaten wurden während des Interviews eingefügt. Dies könnte darauf hindeuten, dass der Kandidat vorbereitete Antworten verwendet hat.",
    "verdicts": {
      "pass": "Bestanden",
      "fail": "Nicht bestanden",
      "unsure": "Unsicher",
      "review": "Überprüfung nötig"
    },
    "optional": "Optional",
    "averageScore": "Durchschnittliche Fragenbewertung",
    "reasoning": "Begründung",
    "evidence": "Beleg",
    "backToJob": "Zurück zur Stelle",
    "overrideDialog": {
      "title": "Bewertung überschreiben",
      "titleVerdict": "Ergebnis überschreiben",
      "currentValue": "Aktueller Wert",
      "newValue": "Neuer Wert",
      "reason": "Grund für die Änderung",
      "reasonPlaceholder": "Erkläre, warum du diese Bewertung änderst...",
      "reasonMinLength": "Mindestens {{min}} Zeichen erforderlich",
      "save": "Änderung speichern",
      "cancel": "Abbrechen",
      "error": "Änderung konnte nicht gespeichert werden. Bitte versuche es erneut."
    }
  },
  "workflows": {
    "title": "Workflow",
    "description": "Konfiguriere die Phasen, die Bewerbungen in deinem Einstellungsprozess durchlaufen.",
    "stages": {
      "title": "Pipeline-Phasen",
      "subtitle": "Zum Sortieren ziehen. Bewerbungen durchlaufen diese Phasen von oben nach unten.",
      "system": "System",
      "manage": "Phasen verwalten",
      "addStage": "Phase hinzufügen",
      "editStage": "Phase bearbeiten",
      "deleteStage": "Phase löschen",
      "stageName": "Phasenname",
      "stageNamePlaceholder": "z.B. Telefonscreening",
      "stageColor": "Farbe",
      "deleteConfirm": "Diese Phase löschen? Bewerbungen in dieser Phase müssen zuerst verschoben werden.",
      "systemProtected": "Systemphasen können nicht gelöscht werden",
      "hasApplications": "Diese Phase enthält noch zugeordnete Bewerbungen"
    }
  },
  "communications": {
    "title": "Agent-Kommunikation",
    "languageSelector": "Sprache",
    "tabs": {
      "sms": "SMS",
      "email": "E-Mail"
    },
    "emailSubject": "Betreff",
    "emailBody": "Inhalt",
    "variables": {
      "applicantName": "Bewerbername",
      "jobTitle": "Stellenbezeichnung",
      "jobEmployer": "Arbeitgeber",
      "jobLocation": "Standort",
      "jobDescription": "Stellenbeschreibung",
      "recruiterName": "Recruitername",
      "inviteUrl": "Einladungslink"
    },
    "actions": {
      "edit": "Bearbeiten",
      "save": "Änderungen speichern",
      "reset": "Auf Standard zurücksetzen",
      "saved": "Vorlage gespeichert",
      "resetDone": "Auf Standard zurückgesetzt"
    },
    "nodes": {
      "interviewIntro": "Interview-Intro",
      "interviewOutro": "Interview-Outro",
      "reminderToFinish": "Erinnerung zum Abschluss",
      "voiceAndChat": "Sprache & Chat",
      "emailsAndSms": "E-Mails & SMS",
      "comingSoon": "Demnächst verfügbar"
    },
    "characters": "{{count}}/{{max}} Zeichen",
    "smsSegments": "{{count}} SMS-Nachrichten ({{size}} Zeichen/Segment)",
    "smsUnicodeWarning": "Diese Nachricht enthält Emojis oder Sonderzeichen, die Unicode-Kodierung erfordern, wodurch das Limit auf 67 Zeichen pro SMS reduziert wird.",
    "invite": {
      "title": "Kandidateneinladung",
      "description": "Kandidaten erhalten diese Nachricht, wenn sie einer Stelle zugewiesen werden. Die E-Mail enthält automatisch einen Link zum Interview.",
      "email": {
        "subject": "Einladung zu Ihrem {{jobTitle}}-Interview! 🎯",
        "body": "<p>Hallo {{applicantName}},</p><p>Sie wurden eingeladen, ein kurzes Online-Screening-Interview mit unserer KI-Interviewerin für die Stelle <strong>{{jobTitle}}</strong> bei <strong>{{jobEmployer}}</strong> zu absolvieren.</p><p>Es ist eine einfache Möglichkeit für uns, Sie besser kennenzulernen — machen Sie es, wann immer Sie bereit sind, von überall aus. Es dauert nur wenige Minuten!</p><p><a href=\"{{inviteUrl}}\">Interview starten</a></p><p>Viel Erfolg!<br>{{jobEmployer}}</p>"
      },
      "sms": "Hallo {{applicantName}}, ich bin Sara, die KI-Assistentin von {{jobEmployer}}. Sie wurden zu einem Interview für {{jobTitle}} eingeladen. Es dauert nur wenige Minuten: {{inviteUrl}} (Keine Antworten)"
    },
    "reminder": {
      "title": "Interview-Erinnerung",
      "description": "Wird automatisch gesendet, wenn ein Kandidat sein Interview nicht innerhalb von 24 Stunden nach Erhalt der Einladung begonnen hat.",
      "email": {
        "subject": "Vergessen Sie nicht Ihr {{jobTitle}}-Interview",
        "body": "<p>Hallo {{applicantName}},</p><p>Wir haben festgestellt, dass Sie Ihr KI-Screening-Interview für die Stelle <strong>{{jobTitle}}</strong> bei <strong>{{jobEmployer}}</strong> noch nicht abgeschlossen haben.</p><p>Dies ist Ihre Chance, einen Schritt weiterzukommen — es dauert nur wenige Minuten, und der Abschluss erhöht Ihre Chancen, in die nächste Phase zu gelangen.</p><p><a href=\"{{inviteUrl}}\">Interview jetzt abschließen</a></p><p>Mit freundlichen Grüßen,<br>{{jobEmployer}}</p>"
      },
      "sms": "Hallo {{applicantName}}, nur eine freundliche Erinnerung — Sie haben Ihr {{jobTitle}}-Interview bei {{jobEmployer}} noch nicht abgeschlossen. Es dauert nur wenige Minuten und erhöht Ihre Chancen: {{inviteUrl}} — Sara"
    },
    "emailBodyPlaceholder": "Schreibe deine E-Mail...",
    "preview": {
      "outroSampleIntro": "Das war alles — vielen Dank für Ihre Antworten!",
      "outroSampleAnswer": "Kein Problem, gerne geschehen."
    },
    "intro": {
      "title": "Interview-Intro",
      "description": "Die genaue Begrüßungsnachricht, die Sara sagt, um den Kandidaten zu begrüßen und zu fragen, ob er bereit ist zu beginnen.",
      "scriptLabel": "Intro-Nachricht",
      "scriptPlaceholder": "Schreibe die genaue Begrüßungsnachricht, die Sara sagen soll...",
      "defaultScript": "Hallo! Ich bin Sara, eine KI-Assistentin für Personalbeschaffung bei {{jobEmployer}}. Vielen Dank, dass Sie sich die Zeit für das Interview zur Stelle {{jobTitle}} nehmen — es dauert nur wenige Minuten. Sind Sie bereit zu beginnen? 😊"
    },
    "outro": {
      "title": "Interview-Outro",
      "description": "Die genaue Abschlussnachricht, die Sara sagt, nachdem alle Fragen beantwortet wurden.",
      "scriptLabel": "Outro-Nachricht",
      "scriptPlaceholder": "Schreibe die genaue Abschlussnachricht, die Sara sagen soll...",
      "defaultScript": "Das war alles — vielen Dank für Ihre Zeit heute! Ein Recruiter wird Ihre Antworten prüfen und sich bei Ihnen melden. Viel Erfolg! 🙂"
    }
  },
  "activity": {
    "title": "Aktivität",
    "stageChange": "Verschoben von {{from}} nach {{to}}",
    "interviewCompleted": "Screening-Interview abgeschlossen",
    "scoreReceived": "Bewertung erhalten: {{score}}/100",
    "applicationCreated": "Bewerbung erstellt",
    "noteAdded": "Notiz hinzugefügt",
    "bySystem": "System",
    "byAi": "KI",
    "empty": "Noch keine Aktivität",
    "emptyTitle": "Noch keine Aktivität",
    "emptyDescription": "Aktionen und Ereignisse für diesen Kandidaten werden hier angezeigt."
  },
  "atsPush": {
    "title": "ATS-Push-Status",
    "retry": "ATS-Push erneut versuchen",
    "retrying": "Wird wiederholt...",
    "rerunStep": "Diesen Schritt erneut ausführen",
    "rerunConfirm": "Dieser Schritt wurde bereits erfolgreich abgeschlossen. Eine erneute Ausführung kann doppelte Daten in deinem ATS erzeugen. Fortfahren?",
    "steps": {
      "transcript": "Protokoll",
      "stage_move": "Phasenwechsel"
    },
    "status": {
      "completed": "Gesendet",
      "failed": "Fehlgeschlagen",
      "pending": "Ausstehend"
    },
    "note": {
      "title": "KI-Screening-Interview",
      "outcome": "Ergebnis",
      "score": "Bewertung",
      "summary": "Zusammenfassung",
      "eligibility": "Eignung",
      "assessment": "Bewertung",
      "transcript": "Protokoll",
      "candidate": "Kandidat",
      "interviewer": "Interviewer",
      "pass": "Bestanden",
      "fail": "Nicht bestanden",
      "review": "Überprüfung",
      "shortlist": "Vorauswahl",
      "reject": "Ablehnen",
      "viewProfile": "Kandidatenprofil in Kiku anzeigen",
      "transcriptAndAssessment": "PROTOKOLL UND BEWERTUNG",
      "intro": "Intro",
      "eligibilityQuestions": "Eignungsfragen",
      "jobExpectations": "Joberwartungen",
      "assessmentQuestions": "Bewertungsfragen",
      "outro": "Outro",
      "assessmentExplanation": "BEWERTUNGSERKLÄRUNG",
      "unsure": "Unsicher",
      "viewInKiku": "FÜR MEHR DETAILS IN KIKU ANZEIGEN",
      "viewProfileLink": "Kandidatenprofil in Kiku anzeigen, um Erklärungen zu den Bewertungen zu sehen"
    }
  },
  "topbar": {
    "whatsNew": "Neuigkeiten",
    "help": "Hilfe",
    "notifications": "Benachrichtigungen"
  },
  "extension_candidate_banner": {
    "description": "Kandidatendetails anzeigen.",
    "description_with_transcript": "Screening-Protokoll & Kandidatendetails anzeigen.",
    "open_in_kiku": "Öffnen",
    "dismiss": "Schließen"
  },
  "languages": {
    "en": "Englisch",
    "da": "Dänisch",
    "sv": "Schwedisch",
    "de": "Deutsch",
    "fr": "Französisch",
    "es": "Spanisch",
    "nl": "Niederländisch",
    "pl": "Polnisch",
    "fi": "Finnisch",
    "ro": "Rumänisch"
  },
  "environmentBanner": {
    "development": "Entwicklung",
    "test": "Test"
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "description": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "goHome": "Zurück zu Kiku"
  },
  "candidateProfile": {
    "title": "Kandidaten",
    "cv": {
      "title": "Lebenslauf",
      "upload": "Lebenslauf hochladen",
      "replace": "Lebenslauf ersetzen",
      "uploadDescription": "Laden Sie einen Lebenslauf hoch, um strukturierte Profildaten zu extrahieren",
      "uploadLimit": "Max. 10 MB — PDF, DOCX, PNG, JPG, WEBP",
      "viewOriginal": "Original-Lebenslauf anzeigen",
      "status": {
        "pending": "In Warteschlange",
        "processing": "Wird verarbeitet...",
        "done": "Verarbeitet",
        "failed": "Verarbeitung fehlgeschlagen"
      },
      "parsed": {
        "title": "Extrahiertes Profil",
        "skills": "Fähigkeiten",
        "experience": "Erfahrung",
        "education": "Ausbildung",
        "languages": "Sprachen",
        "certifications": "Zertifizierungen",
        "present": "Aktuell"
      },
      "errors": {
        "unsupportedType": "Nicht unterstützter Dateityp. Bitte laden Sie eine PDF-, DOCX-, PNG-, JPG- oder WEBP-Datei hoch.",
        "tooLarge": "Datei zu groß. Maximale Größe ist 10 MB.",
        "uploadFailed": "Lebenslauf konnte nicht hochgeladen werden. Bitte versuchen Sie es erneut."
      }
    }
  },
  "results": {
    "exportLabel": "Exportieren",
    "exportCsv": "CSV exportieren",
    "csv": {
      "headers": {
        "candidateName": "Kandidatenname",
        "email": "E-Mail",
        "role": "Rolle",
        "stage": "Phase",
        "overallScore": "Gesamtbewertung",
        "outcome": "Ergebnis",
        "eligibility": "Eignung",
        "expectations": "Erwartungen",
        "avgScore": "Durchschnittsnote",
        "interviewDate": "Interviewdatum",
        "status": "Status"
      }
    },
    "emptyTitle": "Noch keine Ergebnisse",
    "emptyDescription": "Abgeschlossene Interviews werden hier angezeigt.",
    "columns": {
      "candidate": "Kandidat",
      "stage": "Phase",
      "status": "Status",
      "score": "Bewertung",
      "outcome": "Ergebnis",
      "eligibility": "Eignung",
      "expectations": "Erwartungen",
      "avgScore": "Durchschnittsnote",
      "interviewDate": "Interviewdatum",
      "question": "Frage"
    },
    "statusLabels": {
      "pending": "Ausstehend",
      "processing": "In Bearbeitung",
      "completed": "Abgeschlossen",
      "failed": "Fehlgeschlagen",
      "no_interview": "Kein Interview"
    },
    "questionSections": {
      "eligibility": "Eignung",
      "job_preview": "Erwartungen",
      "nice_to_have": "Wünschenswert",
      "assessment": "Bewertung",
      "information": "Information"
    },
    "fields": {
      "reasoning": "Begründung",
      "evidence": "Beleg",
      "response": "Antwort",
      "avgScoreLabel": "Durchschnittsnote",
      "interviewDate": "Interviewdatum"
    }
  },
  "orgSettings": {
    "title": "Organisationseinstellungen",
    "branding": {
      "title": "Branding",
      "logo": "Organisationslogo",
      "logoDescription": "Lade ein Logo hoch, um das Standard-Kiku-Logo in der Navigationsleiste zu ersetzen.",
      "uploadLogo": "Logo hochladen",
      "removeLogo": "Logo entfernen",
      "logoHint": "PNG, JPG, WebP oder SVG. Max. 2 MB.",
      "uploadSuccess": "Logo erfolgreich aktualisiert",
      "removeSuccess": "Logo entfernt",
      "uploadError": "Logo konnte nicht hochgeladen werden"
    },
    "timezone": {
      "title": "Zeitzone",
      "description": "Lege die Standardzeitzone für Planung und Datumsanzeige fest.",
      "label": "Zeitzone",
      "saveSuccess": "Zeitzone aktualisiert",
      "saveError": "Zeitzone konnte nicht aktualisiert werden"
    },
    "save": "Änderungen speichern"
  },
  "mcp": {
    "title": "MCP-Integration",
    "subtitle": "Verbinde KI-Assistenten mit Kiku über das Model Context Protocol",
    "whatIsMcp": "Was ist MCP?",
    "whatIsMcpDescription": "Das Model Context Protocol (MCP) ermöglicht es KI-Assistenten wie Claude, ChatGPT und anderen Tools, direkt mit Kiku zu interagieren — Stellen auflisten, Kandidaten einsehen und deine Recruiting-Pipeline per natürlicher Sprache verwalten.",
    "serverUrl": "Server-URL",
    "copyUrl": "URL kopieren",
    "copied": "Kopiert!",
    "availableTools": "Verfügbare Tools",
    "toolListJobs": "Stellenanzeigen mit Abteilungsnamen suchen und auflisten, mit Filtern für Status, Einrichtungsstatus und Abteilung.",
    "toolGetJob": "Alle Details einer bestimmten Stellenanzeige abrufen, einschließlich Abteilungsname.",
    "toolCreateJob": "Eine neue Stellenanzeige in einer Abteilung erstellen.",
    "toolAdvanceSetup": "Eine Stelle durch die Setup-Phasen führen (Entwurf, Fragen ausstehend, bereit, aktiv).",
    "toolListApplications": "Bewerbungen für eine Stelle mit Phasennamen, Bewertungsstatus und Ergebnis auflisten.",
    "toolGetInterviewResults": "KI-Interviewergebnisse für eine Bewerbung abrufen — Punktzahl, Ergebnis und Aufschlüsselung pro Frage mit Begründung.",
    "toolGetPipelineSummary": "Pipeline-Übersicht für eine Stelle abrufen — Kandidatenanzahl pro Phase mit Bestanden/Nicht-bestanden-Gesamtzahlen.",
    "setupTitle": "Einrichtung mit Claude Desktop",
    "setupStep1": "Öffnen Sie Claude Desktop",
    "setupStep2": "Klicken Sie auf Customize in der linken Seitenleiste",
    "setupStep3": "Klicken Sie auf Connectors, dann das +-Symbol, dann Add custom connector",
    "setupStep4": "Geben Sie Name: Kiku und die oben gezeigte Server-URL ein",
    "setupStep5": "Klicken Sie auf Add — Claude kann jetzt Ihre Kiku-Daten verwenden"
  }
}
